import React from 'react'
import Layout from '../../components/Layout'
import { useParams } from 'react-router-dom'
import { get_opsenPajakKendaraan_act, get_rasioKepatuhanPajak_act } from '../../../redux/ducks/home/actions'
import { connect } from 'react-redux'
import { numberFormatter } from '../../helper'

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const OpsenPajakDaerah = (props) => {
    const [rasio, setRasio] = React.useState([])
    const [kabkota, setKabkota] = React.useState([])
    const [jmlKendaraan, setJmlKendaraan] = React.useState([])
    const { yearconfig } = useParams()
    const colorsPool = [
        "rgba(255, 99, 132, 0.8)",   // Merah muda
        "rgba(54, 162, 235, 0.8)",   // Biru cerah
        "rgba(255, 206, 86, 0.8)",   // Kuning
        "rgba(75, 192, 192, 0.8)",   // Hijau kebiruan
        "rgba(153, 102, 255, 0.8)",  // Ungu muda
        "rgba(255, 159, 64, 0.8)",   // Oranye
        "rgba(201, 203, 207, 0.8)",  // Abu-abu muda
        "rgba(255, 99, 71, 0.8)",    // Tomat
        "rgba(60, 179, 113, 0.8)",   // Hijau sedang
        "rgba(106, 90, 205, 0.8)",   // Biru royal
        "rgba(0, 191, 255, 0.8)",    // Deep Sky Blue
        "rgba(255, 215, 0, 0.8)",    // Emas
        "rgba(220, 20, 60, 0.8)",    // Crimson
        "rgba(32, 178, 170, 0.8)",   // Light Sea Green
        "rgba(218, 112, 214, 0.8)",  // Orchid
        "rgba(244, 164, 96, 0.8)",   // Sandy Brown
        "rgba(100, 149, 237, 0.8)",  // Cornflower Blue
        "rgba(189, 183, 107, 0.8)",  // Dark Khaki
        "rgba(72, 209, 204, 0.8)"    // Medium Turquoise
    ]
    const breadCrumbsData = [
        {
        title: 'Home',
        isActive: true,
        goTo: '/tahun/'+yearconfig,
        },
        {
        title: 'Detail Pendapatan',
        isActive: true,
        goTo: '/tahun/' + yearconfig + '/bappenda/detail-pendapatan',
        },
        ,
        {
        title: 'Opsen Pajak',
        isActive: false,
        goTo: '',
        },
    ];
    React.useEffect(() => {
        props.get_opsenPajakKendaraan_act(yearconfig)
    },[])
    React.useEffect(() => {
        props.get_rasioKepatuhanPajak_act()
    },[])
    React.useEffect(() => {
        let labels = []
        let rasio = []
        let jmlkend = []
        if(props.rasioKepatuhanPajak.data.length > 0){
            props.rasioKepatuhanPajak.data.map((item) => {
                labels.push(item.KabKota)
                rasio.push(parseFloat(item.Persentase_Kepatuhan))
                jmlkend.push(item.Jumlah_Kendaraan)
            })
        }
        
        setKabkota(labels)
        setRasio(rasio)
        setJmlKendaraan(jmlkend)
    },[props.rasioKepatuhanPajak])
    const dataBar = {
        labels: kabkota,
        datasets: [
            {
                axis: 'y',
                label: 'Persentase',
                data: rasio,
                fill: false,
                backgroundColor: colorsPool,
                borderColor: colorsPool,
                borderWidth: 1,
                barPercentage: 0.7,
            },
        ],
    };

    const options = {
        scales: {
            x: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function (value, index, ticks) {
                        return kabkota[index];
                    },
                    color: 'black',
                    font: {
                        family: 'Poppins, sans-serif',
                        size: 12,
                    },
                },
            },
            y: {
                ticks: {
                    callback: function (value, index, ticks) {
                        if (parseInt(value) >= 1000) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '%';
                        } else {
                            return value + '%';
                        }
                    },
                },
            },
        },
        indexAxis: 'x',
        elements: {
            bar: {
                borderWidth: 20,
            },
        },
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Rasio Kepatuhan Pajak Kendaraan Bermotor',
                color: 'black',
                font: {
                    size: 18,
                    family: 'Poppins, sans-serif',
                },
            },
            datalabels: {
                color: 'black',
                align: 'end',
                anchor: 'end',
                font: {
                    size: 12,
                },
                formatter: function (value) {
                    return `${value} %`;
                },
            },
        },
    };
    const dataPie = {
        labels: kabkota,
        datasets: [
            {
                label: 'Jumlah Kendaraan',
                data: jmlKendaraan,
                backgroundColor: colorsPool,
                borderColor: colorsPool,
                borderWidth: 1,
            },
        ],
    };
    const optionsPie = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            
            title: {
                display: true,
                text: 'Rasio Jumlah Kendaraan Bermotor',
                color: 'black',
                font: {
                    size: 18,
                    family: 'Poppins, sans-serif',
                },
            },
            datalabels: {
                color: 'black',
                align: 'end',
                anchor: 'end',
                font: {
                size: 12,
            },
            formatter: function (value) {
                    return `${value}`;
                },
            },
        },
    };

    return (
        <Layout
            breadCrumbsData={breadCrumbsData}
        >
            <div className="space-y-5 gap-5">
                <div className="bg-white p-2 rounded-lg animate__animated animate__fadeIn">
                    <div className="flex-grow bg-white rounded-xl py-2 relative">
                        <h1 className="text-xl font-bold text-primeColor1 text-center">Opsen Pajak Kendaraan Bermotor</h1>
                        <h1 className="text-md text-secondaryColor1 text-center">Tahun {yearconfig}</h1>
                        <hr className="mb-3" />
                    </div>
                    <div className="w-full sm:overflow-visible overflow-x-auto flex flex-col justify-center">
                        <table className="w-full table-auto text-xs mb-4">
                            <thead className="bg-primeColor1 text-white sticky top-0">
                                <tr>
                                    <th className="border border-slate-500  w-[2%]" rowSpan={2}>
                                        No
                                    </th>
                                    <th className="border border-slate-500 md:w-1/3" rowSpan={2}>
                                        Kabupaten/Kota
                                    </th>
                                    <th className="border border-slate-500" colSpan={4}>
                                        PKB
                                    </th>
                                    <th className="border border-slate-500" colSpan={4}>
                                        BBNKB
                                    </th>
                                </tr>
                                <tr>
                                    <th className="border border-slate-500">
                                        Unit
                                    </th>
                                    <th className="border border-slate-500">
                                        Pokok
                                    </th>
                                    <th className="border border-slate-500">
                                        Denda
                                    </th>
                                    <th className="border border-slate-500">
                                        JumlahOpsen
                                    </th>
                                    <th className="border border-slate-500">
                                        Unit
                                    </th>
                                    <th className="border border-slate-500">
                                        Pokok
                                    </th>
                                    <th className="border border-slate-500">
                                        Denda
                                    </th>
                                    <th className="border border-slate-500">
                                        JumlahOpsen
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.opsenPajakKendaraanState.loading ? 
                                    <tr>
                                        <td className='border border-slate-500 text-center' colSpan={'100%'}>
                                            Loading...
                                        </td>
                                    </tr> :
                                    (props.opsenPajakKendaraanState.data.length > 0 ? 
                                        props.opsenPajakKendaraanState.data.map((item, key) => (
                                            <tr className='even:bg-primeColor2'>
                                                <td className='border border-slate-500 text-right' >{key+1}.</td>
                                                <td className='border border-slate-500' >{item.KabKota}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.pkb.Unit)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.pkb.OpsPKB_Pokok)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.pkb.OpsPKB_Denda)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.pkb.TotalOpsPKB)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.bbnkb.Unit)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.bbnkb.OpsBBNKB_Pokok)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.bbnkb.OpsBBNKB_Denda)}</td>
                                                <td className='border border-slate-500 text-right' >{numberFormatter(item.bbnkb.TotalOpsBBNKB)}</td>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td className='border border-slate-500 text-center' colSpan={'100%'}>
                                                No Data
                                            </td>
                                        </tr>
                                    )

                                }
                                <tr className='bg-primeColor1 text-white'>
                                    <td className='border border-slate-500 text-center' colSpan={2}>
                                        Total
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.pkb?.jumlahUnit ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.pkb?.jumlahOpsPKB_Pokok ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.pkb?.jumlahOpsPKB_Denda ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.pkb?.jumlahTotalOpsPKB ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.bbnkb?.jumlahUnit ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.bbnkb?.jumlahOpsBBNKB_Pokok ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.bbnkb?.jumlahOpsBBNKB_Denda ?? 0)}
                                    </td>
                                    <td className='border border-slate-500 text-right'>
                                        {numberFormatter(props.opsenPajakKendaraanState.totals?.bbnkb?.jumlahTotalOpsBBNKB ?? 0)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="">
                    <div className="w-full flex md:flex-row flex-col py-2 px-5 gap-5">
                        <div className="md:w-1/2 w-full h-96 bg-white p-2 rounded-lg animate__animated animate__fadeIn">
                            <Bar data={dataBar} options={options} />
                        </div>
                        <div className="md:w-1/2 w-full flex justify-center bg-white p-2 rounded-lg animate__animated animate__fadeIn">
                            <Pie data={dataPie} options={optionsPie} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

const mapStateProps = (state) => {
    return {
        opsenPajakKendaraanState: state.homeState.opsenPajakKendaraan,
        rasioKepatuhanPajak: state.homeState.rasioKepatuhanPajak
    }
}

const mapDispatchToProps = {
    get_opsenPajakKendaraan_act,
    get_rasioKepatuhanPajak_act
}

const withConnect = connect(mapStateProps, mapDispatchToProps)

export default withConnect(OpsenPajakDaerah)